import { TimetableVersionSubjectsMatrix } from '../../../../../../components/TimetableVersion/TimetableVersionDataAvailabilityMatrix/TimetableVersionSubjectsMatrix';
import { TimetableVersionSubjectConditions } from '../../../../../../components/TimetableVersion/TimetableVersionDataConditions/TimetableVersionSubjectConditions';
import { TimetableVersionSubjectsTable } from '../../../../../../components/TimetableVersion/TimetableVersionDataTables/TimetableVersionSubjectsTable';
import { hexToColorOption } from '../../../../../../utils/colorUtils';
import { TimetableResourceDataPage, timetableResourceConfig } from '../TimetableResourceDataPage';

const subjectConfig = timetableResourceConfig({
  availabilityResourceType: 'subject',
  relationKey: 'subjects',
  lessonFilterColumn: 'subject',
  importLabelKey: 'subject.title',
  selectVersionUuids: (store) => Array.from(store.subjects.keys()),
  selectEntities: (basicData) => basicData.subjectData?.subjects,
  mapRow: (s) => {
    const { html, label } = hexToColorOption(s.timetableConfig?.color ?? '');
    return {
      uuid: s.uuid,
      name: s.name,
      count: 0,
      shortName: s.shortName,
      color: { color: html, colorLabel: label },
    };
  },
  addEntities: (store, entities) => store.addSubjects([...entities]),
  removeEntities: (store, uuids) => store.removeSubjects(uuids),
  renderMatrix: ({ selected, loading, versionUuid, timeGridEntries, onChange }) => (
    <TimetableVersionSubjectsMatrix
      timeGridEntries={timeGridEntries}
      versionUuid={versionUuid}
      selected={selected}
      loading={loading}
      onChange={onChange}
    />
  ),
  renderTable: ({ versionUuid, versionUuids, search, onRowSelection, onRemove, onShowLessonClick }) => (
    <TimetableVersionSubjectsTable
      onRowSelection={onRowSelection}
      versionUuid={versionUuid}
      versionSubjectUuids={versionUuids}
      search={search}
      onRemove={onRemove}
      onShowLessonClick={onShowLessonClick}
    />
  ),
  renderConditions: ({ versionUuid, selected, ...control }) =>
    versionUuid && selected ? (
      <TimetableVersionSubjectConditions
        key={selected.uuid}
        versionUuid={versionUuid}
        subjectUuid={selected.uuid}
        name={selected.name}
        {...control}
      />
    ) : null,
});

export const PlanTimetableSubjects = () => <TimetableResourceDataPage config={subjectConfig} />;
